module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD3SURBVEhL7ZFBDgFBEEUnSLiEhQu4hKUbuIYD2BJxGnuXsLews7Flhf+kO/kZzfQMCxEveZnq6uqqSar4Y1yD2cQHOYLHWXiDKsHjLLxBleBxbRbSG+JcOjHfiI5cykOQgW35EfyvU75Nqqn7/Yxl6s+Ru7foyZ2k2T58PeaOmsbMJI0uchRiJCZHTE0jBvIkabIiIeIAIEdMDbW1WUsabGWXhPAB5LjjTG0t4mLPckgi4AOAO2rIZS/cFzslYZQHADXkshceF7uRLRJGagA11JKvXHhc7FH2SZRIDQBqeVO58LjYyf30yLMBwBvuai/ceTXgJymKGz4biRI/UEgQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-land-surveying/dark/24.png
// module id = 2214
// module chunks = 2